module.exports = __webpack_public_path__ + "images/Square.png";